import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ASSETS } from "#/lib/assets";
import { ROUTES } from "#/lib/routes";
import { useReveal } from "#/lib/useReveal";
import { PillBtn } from "../primitives.js";

const REVEAL_TRANSITION =
  "transform 900ms cubic-bezier(0.22, 1, 0.36, 1), opacity 700ms ease-out";

export function BjuPressFeature() {
  const [frame, setFrame] = useState(0);
  const total = ASSETS.bjuSets.length;
  const { ref, revealed } = useReveal<HTMLDivElement>(0.4);

  useEffect(() => {
    if (!revealed) return;
    const id = window.setInterval(() => {
      setFrame((i) => (i + 1) % total);
    }, 3500);
    return () => window.clearInterval(id);
  }, [total, revealed]);

  const set = ASSETS.bjuSets[frame] ?? null;

  return (
    <section className="overflow-x-clip pt-20 pb-24 md:pt-32 md:pb-40">
      <div className="mx-auto mb-12 w-full max-w-figma px-6 md:mb-16 md:px-10">
        <div className="mx-auto h-px w-full max-w-[1080px] bg-lp-green-mid" />
      </div>
      <div ref={ref} className="mx-auto w-full max-w-figma px-6 md:px-10">
        <div className="flex flex-col items-center gap-10 lg:flex-row lg:items-center lg:gap-12">
          <div
            className="w-full lg:w-[45%]"
            style={{
              opacity: revealed ? 1 : 0,
              transform: revealed ? "translateX(0)" : "translateX(-60px)",
              transition: REVEAL_TRANSITION,
            }}
          >
            <img
              src={ASSETS.bjuLogo}
              alt="BJU Press"
              loading="lazy"
              decoding="async"
              className="h-44 w-auto md:h-56"
            />
            <p className="m-0 mt-6 max-w-md font-display text-base text-lp-text leading-relaxed md:text-lg">
              BJU Press provides educational materials written from a biblical
              worldview that focus on academic rigor and encourage critical
              thinking—all supported by appropriate educational technology.
            </p>
            <div className="mt-8 md:mt-10">
              <Link
                to={ROUTES.shop}
                search={{ category: ["bju-sets"], page: 1, sort: "default" }}
              >
                <PillBtn variant="green">Shop Now</PillBtn>
              </Link>
            </div>
          </div>

          <div
            className="relative w-full lg:w-[55%]"
            style={{
              opacity: revealed ? 1 : 0,
              transform: revealed ? "translateX(0)" : "translateX(60px)",
              transition: REVEAL_TRANSITION,
              transitionDelay: "120ms",
            }}
          >
            <div className="relative mx-auto h-[600px] w-[600px] max-w-full">
              <div className="absolute top-[130px] left-[-20px] h-[360px] w-[1100px] rounded-l-[180px] rounded-r-[40px] bg-lp-green-soft" />
              {set ? (
                <img
                  key={frame}
                  src={set}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 m-auto h-auto max-h-[600px] w-auto max-w-[600px] object-cover animate-in slide-in-from-right-[60px] duration-[360ms] ease-bju"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
